module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p15"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "images/img2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  }, [_c('span', {
    staticClass: "t8"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Life has been known by a series of constants: violence, anger, drugs, sex, death, heartbreak, pain, fear, and, the most common, hunger. Always hunger. Not the kind that can be satisfied with food, but the kind born of circumstance. The kind that not only claws within a gut, but settles into a heart, consumes a mind. Deeper—encircles, penetrates the soul. Hunger for something more, something better, safer. Always just out of grasp—craving—starved.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("It’s part of me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Who I am.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Born of blood and violence, hunger is my fate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Yet, the slightest things can change the directions of a life. An unplanned circumstance, random act—a connection—a chance event, like a lightning strike, fate is trumped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Jamie is my lightning strike.")])]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p16"
  }, [_c('span', {
    staticClass: "t9"
  }, [_vm._v("Tek Cain")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b1b1e36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008.vue
// module id = 75
// module chunks = 0